export const heroSlides = [
  {
    videoId: "v-g1",
    image:
      "https://readdy.ai/api/search-image?query=dark%20navy%20esports%20arena%20wide%20shot%20with%20vivid%20orange%20stage%20lights%20and%20holographic%20screens%2C%20crowd%20silhouettes%20watching%20a%20glowing%20central%20screen%2C%20cinematic%20dramatic%20and%20moody%20lighting%2C%20high%20contrast%20digital%20illustration&width=1280&height=720&seq=zbhero01-2026&orientation=landscape",
    badge: "焦点直播",
    kicker: "巅峰对局精选",
    headline: "王者荣耀五杀收割全记录",
    subline: "顶尖选手团战进场时机逐帧复盘，一次看懂高分段收割思路。",
  },
  {
    videoId: "v-t1",
    image:
      "https://readdy.ai/api/search-image?query=dark%20navy%20concert%20stage%20wide%20shot%20with%20warm%20orange%20spotlight%20beams%20cutting%20through%20haze%2C%20a%20singer%20silhouette%20center%20stage%20holding%20a%20microphone%2C%20cinematic%20dramatic%20moody%20lighting&width=1280&height=720&seq=zbhero02-2026&orientation=landscape",
    badge: "才艺推荐",
    kicker: "通宵高音挑战",
    headline: "从凌晨唱到天亮的现场",
    subline: "数小时不间演唱会，观众投票决定下一首，气氛拉满。",
  },
  {
    videoId: "v-g7",
    image:
      "https://readdy.ai/api/search-image?query=dark%20navy%20voxel%20game%20world%20wide%20panorama%20with%20warm%20orange%20sunset%20glow%2C%20a%20small%20blocky%20character%20before%20an%20elaborate%20fortress%20on%20square%20terrain%2C%20cinematic%20moody%20lighting%2C%20high%20contrast&width=1280&height=720&seq=zbhero03-2026&orientation=landscape",
    badge: "热门系列",
    kicker: "极限生存百天",
    headline: "我的世界第100天里程碑",
    subline: "从徒手开局到自动化农场，一百天的生存挑战全回顾。",
  },
];